import React from "react";
var __jsx = React.createElement;
import { useParams } from "react-router-dom";
import Tag from "./Tag/Tag";
import stl from "./SelectedTags.module.css";
import useHelpers from "@hooks/useHelpers";
var SelectedTags = function SelectedTags(_ref) {
  var tags = _ref.tags,
    className = _ref.className;
  var _useParams = useParams(),
    make = _useParams.make,
    model = _useParams.model;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var createTagUrl = function createTagUrl(tag) {
    if (tag.filterField === "make_id" || tag.filterField === "condition_id") {
      return createUrl("/autos");
    }
    if (tag.filterField === "model_id") {
      return createUrl("/autos/".concat(make));
    }
    return createUrl("/autos/".concat(make, "/").concat(model));
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "posts-seo-chips-selected-tags",
    className: "".concat(stl.wrapper, " ").concat(className || "")
  }, /*#__PURE__*/React.createElement("div", null, tags.map(function (tag, i) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: i,
      id: "posts-seo-chip-selected-".concat(tag.filterField, "-").concat(tag.id),
      title: tag.type === "range" ? tag.range_values.from : tag.name,
      url: createTagUrl(tag)
    });
  })));
};
export default SelectedTags;